import { useEffect, useState } from "react";

export const useAspectRatio = (imgSrc: string) => {
    const [aspectRatio, setAspectRatio] = useState<number>(0);
    useEffect(() => {
      if (!imgSrc) {
        return setAspectRatio(0);
      }
      const image = new Image();
      image.onload = () => setAspectRatio(image.naturalWidth / image.naturalHeight);
      image.onerror = () => setAspectRatio(0);
      image.src = imgSrc;
      return () => {
        image.onload = null;
        image.onerror = null;
      };
    }, [imgSrc]);
    return aspectRatio;
  };
